import { useState } from 'react';
import { t } from '../../../languages';

/* import {
    EmailIcon,
    EmailShareButton,
    FacebookIcon,
    FacebookShareButton,
    LinkedinIcon,
    LinkedinShareButton,
    RedditIcon,
    RedditShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
    WhatsappIcon,
    WhatsappShareButton
} from 'react-share'; */

import './index.less';
import { set } from 'react-ga';

const SocialShare = ({ lang }) => {
    const [shared, setShared] = useState(false);

    const shareUrl = 'https://misoroban.com/products/app-abaco-japones-soroban/';
    // const shareUrl = 'https://misoroban.com/';

    const handleShare = () => {
        const shareUrl = 'https://misoroban.com/products/app-abaco-japones-soroban/';

        const data = {
            title: 'MiSoroban',
            text: t(lang, 'sharemess'),
            url: shareUrl,
        }


        if (navigator.share) {
            navigator
                .share(data)
                .then(() => {
                    setShared(true);
                })
                .catch(console.error);
        } else {
            window.open(`https://www.facebook.com/sharer.php?u=${data.url.trim()}&quote=${data.text}`, '_blank');
        }
    };

    return (
        <section className='social-share'>
            <ul>
                {/* <li>
                    <FacebookShareButton url={shareUrl} hashtags={['soroban', 'cálculomental']}>
                        <FacebookIcon size={32} round={true} />
                    </FacebookShareButton>
                </li>
                <li>
                    <TwitterShareButton url={shareUrl} hashtags={['soroban', 'cálculomental']}>
                        <TwitterIcon size={32} round={true} />
                    </TwitterShareButton>
                </li>
                <li>
                    <WhatsappShareButton url={shareUrl} hashtags={['soroban', 'cálculomental']}>
                        <WhatsappIcon size={32} round={true} />
                    </WhatsappShareButton>
                </li>
                <li>
                    <TelegramShareButton url={shareUrl} >
                        <TelegramIcon size={32} round={true} />
                    </TelegramShareButton>
                </li>
                <li>
                    <EmailShareButton url={shareUrl} >
                        <EmailIcon size={32} round={true} />
                    </EmailShareButton>
                </li>
                <li>
                    <LinkedinShareButton url={shareUrl} >
                        <LinkedinIcon size={32} round={true} />
                    </LinkedinShareButton>
                </li>
                <li>
                    <RedditShareButton url={shareUrl} >
                        <RedditIcon size={32} round={true} />
                    </RedditShareButton>
                </li> */}

                <li onClick={handleShare} >
                    <img src="./static/action-buttons/send.svg" alt="" />
                    <span>  {shared ? t(lang, 'thankssharing') : null}</span>
                </li>

            </ul>

        </section>
    );
};

export default SocialShare;